import axios from "axios";
import React, { memo, useEffect, useRef, useState } from "react";
import cookie from "react-cookies";
import CurrencyFormat from "react-currency-format";
import { useIdleTimer } from "react-idle-timer";
import OrderDetails from "../../components/common/OrderDetails";
import TopActiveDriversPanel from "../../components/common/TopActiveDriversPanel";
import DriverTripsDrawer from "../../components/common/DriverTripsDrawer";
import DashboardInsightCards from "../../components/common/DashboardInsightCards";
import "../../components/common/DashboardInsightCards.css";
import { Tooltip, Tour } from "antd";

import {
  Button,
  Col,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
  Table,
} from "reactstrap";
import constants from "../../Constants";
import BookTripModal from "../../components/common/BookTripModal";
import IdleModal from "../../components/common/IdleModal";
import PaymentsPromptModal from "../../components/common/PaymentsPromptModal";
import PlacesAutocomplete from "../../components/common/PlacesAutocomplete";
import { writeToLocalStorage } from "../../localStorage.js";
import {
  downloadCustomerInvoice,
  getTrackOrderPayUrl,
  isOrderPaid,
} from "../../utils/customerInvoice";
let _ = require("lodash");
const moment = require("moment");

const baseURL = constants.baseURL;
const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const Authorization = (method) => ({
  method,
  headers: {
    "Content-Type": "application/json",
    Authorization: cookie.load("session-id-qt"),
  },
});
function MyComponent() {
  const [oPaginator, setOPaginator] = useState(0);
  // const [updatingVehicle, setUpdatingVehicle] = useState(false);

  const [addingConversation, setAddingConversation] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [orderconversations, setOrderconversations] = useState([]);
  const [startChat, setStartChat] = useState("");
  const [order, setOrder] = useState(null);
  const [findADriver, setFindADriver] = useState(undefined);
  const [filterDrivers, setFilterDrivers] = useState("");
  const [orderFiles, setOrderFiles] = useState([]);
  const [assignedVehicle, setAssignedVehicle] = useState(undefined);
  const [nearbyVehicles, setNearbyVehicles] = useState([]);
  const [assigningVehicle, setAssigningVehicle] = useState(false);
  const [loadingVehicles, setLoadingVehicles] = useState(false);
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [ordersFilter, filterOrders] = useState({
    orderstatus: "accepted",
    vehicleid: "all",
    search: "all",
  });
  // Dropdown state removed as we're using tiles now
  // const [ordersFilter, filterOrders] = useState({
  //   orderstatus: "in-review",
  //   vehicleid: true,
  //   search: "all",
  // });

  const [ordersonly, setOrdersOnly] = useState([]);
  const [processedFilter, setProcessedFilter] = useState("");

  const [vehicles, setVehicles] = useState([]);
  const [quotations, setQuotations] = useState([]);
  const [loadingQuotations, setLoadingQuotations] = useState(false);
  const [showQuotations, setShowQuotations] = useState(false);
  const [topActiveDrivers, setTopActiveDrivers] = useState([]);
  const [loadingTopDrivers, setLoadingTopDrivers] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [driverTrips, setDriverTrips] = useState([]);
  const [loadingDriverTrips, setLoadingDriverTrips] = useState(false);
  const [tourOpen, setTourOpen] = useState(false);
  const [downloadingInvoiceId, setDownloadingInvoiceId] = useState(null);
  const topDriversRef = useRef(null);
  const quotationsRef = useRef(null);
  const statusFilterRef = useRef(null);
  const fetchVehiclesDrivers = (mounted) => {
    setLoadingVehicles(true);
    fetch(baseURL + "/customer-vehicles?vehiclestatus=availableresting", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: cookie.load("session-id-qt"),
      },
    })
      .then((data) => data.json())
      .then((json) => {
        if (mounted) {
          setVehicles(json);
          setLoadingVehicles(false);
        }
      })
      .catch((e) => {
        console.log(e);
        if (mounted) {
          setVehicles([]);
          setLoadingVehicles(false);
        }
      });
  };
  const fetchQuotations = () => {
    setLoadingQuotations(true);
    axios
      .get(baseURL + "/customer-quotations-list", {
        headers: {
          "Content-Type": "application/json",
          Authorization: cookie.load("session-id-qt"),
        },
      })
      .then((response) => {
        setQuotations(response.data || []);
      })
      .catch((e) => {
        console.log("fetchQuotations error", e);
        setQuotations([]);
      })
      .finally(() => setLoadingQuotations(false));
  };
  const fetchTopActiveDrivers = () => {
    setLoadingTopDrivers(true);
    axios
      .get(baseURL + "/customer-top-active-drivers", Authorization("GET"))
      .then((response) => {
        setTopActiveDrivers(response.data || []);
      })
      .catch((e) => {
        console.log("fetchTopActiveDrivers error", e);
        setTopActiveDrivers([]);
      })
      .finally(() => setLoadingTopDrivers(false));
  };
  const fetchDriverRecentTrips = (vehicleid) => {
    setLoadingDriverTrips(true);
    setDriverTrips([]);
    axios
      .get(
        baseURL + "/customer-driver-recent-trips?vehicleid=" + vehicleid,
        Authorization("GET")
      )
      .then((response) => {
        setDriverTrips(response.data || []);
      })
      .catch((e) => {
        console.log("fetchDriverRecentTrips error", e);
        setDriverTrips([]);
      })
      .finally(() => setLoadingDriverTrips(false));
  };
  const duplicateTripAsNewBooking = (trip) => {
    // Strip identifiers so BookTripModal treats it as a fresh booking,
    // but keep the driver's vehicleid so the quote is re-assigned to the
    // same driver and their profile shows on the Quote step.
    const {
      orderid,
      quoteid,
      paymentid,
      orderstatus,
      deliverystatus,
      dateadded,
      quotevehicleid,
      driverid,
      driverfirstname,
      driverlastname,
      drivermobilenumber,
      licenseplatenumber,
      comments,
      statuses,
      ...rest
    } = trip || {};
    const driverForBanner =
      selectedDriver && selectedDriver.vehicleid === trip?.vehicleid
        ? selectedDriver
        : trip?.vehicleid
        ? {
            vehicleid: trip.vehicleid,
            firstname: trip.driverfirstname,
            lastname: trip.driverlastname,
            trucktype: trip.trucktype,
          }
        : null;
    setSelectedDriver(null);
    bookOnDemandVehicle({
      trucktype: trip?.trucktype,
      vehicleid: trip?.vehicleid,
      order: { ...rest, vehicleid: trip?.vehicleid },
      driver: driverForBanner,
    });
  };
  // Book again with a top active driver - fetches their latest trip and
  // prefills the modal so the user lands on the Your Quote step.
  const rebookWithTopDriver = (driver) => {
    if (!driver || !driver.vehicleid) return;
    setShowBookTripModal(false);
    setLoadingDriverTrips(true);
    axios
      .get(
        baseURL +
          "/customer-driver-recent-trips?vehicleid=" +
          driver.vehicleid,
        Authorization("GET")
      )
      .then((response) => {
        const trips = response.data || [];
        if (trips.length === 0) {
          // No previous trips - open a blank booking for this driver anyway
          bookOnDemandVehicle({
            trucktype: driver.trucktype,
            vehicleid: driver.vehicleid,
            order: { vehicleid: driver.vehicleid },
            driver,
          });
          return;
        }
        const latestTrip = trips[0];
        // Strip identifiers but keep the driver's vehicleid so the quote is
        // assigned back to this driver.
        const {
          orderid,
          quoteid,
          paymentid,
          orderstatus,
          deliverystatus,
          dateadded,
          driverid,
          driverfirstname,
          driverlastname,
          drivermobilenumber,
          licenseplatenumber,
          comments,
          statuses,
          ...rest
        } = latestTrip;
        // Fill in any fields that the test/historic trip may be missing so
        // validStepOne() passes and the modal can auto-advance to the quote.
        const fallbackMobile = cookie.load("ctMobile") || "";
        if (!rest.mobilenumber) rest.mobilenumber = fallbackMobile;
        if (!rest.prospectmobilenumber)
          rest.prospectmobilenumber = rest.mobilenumber || fallbackMobile;
        if (!rest.description)
          rest.description = "Rebooking with " + driver.firstname;
        bookOnDemandVehicle({
          trucktype: latestTrip.trucktype || driver.trucktype,
          vehicleid: driver.vehicleid,
          order: { ...rest, vehicleid: driver.vehicleid },
          driver,
        });
      })
      .catch((e) => {
        console.log("rebookWithTopDriver error", e);
        // Fallback: reopen a blank booking
        bookOnDemandVehicle({
          trucktype: driver.trucktype,
          vehicleid: driver.vehicleid,
          order: { vehicleid: driver.vehicleid },
          driver,
        });
      })
      .finally(() => setLoadingDriverTrips(false));
  };
  const openTripFromDriverPanel = (trip) => {
    setSelectedDriver(null);
    getOrderConversations(trip.orderid);
    setStartChat("ax-x-x" + trip.orderid);
    setOrder(trip);
  };
  const fetchOrders = (mounted) => {
    setLoadingOrders(true);

    fetch(baseURL + "/customer-orders", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: cookie.load("session-id-qt"),
      },
    })
      .then((data) => data.json())
      .then((json) => {
        setOrdersOnly(json);
        setLoadingOrders(false);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  function getTimeRemaining(targetDate) {
    // Get the current date/time.
    let now = new Date();

    // Get the target date/time.
    let target = new Date(targetDate);

    // Calculate the difference in milliseconds.
    let diffMs = target - now;

    // Check if the target date is in the past.
    if (diffMs < 0) {
      console.log("The target date is in the past!");
      return;
    }

    // Calculate the difference in minutes and hours.
    let diffMinutes = Math.floor(diffMs / 60000);
    let diffHours = Math.floor(diffMinutes / 60);

    // Get the remaining minutes after removing the hours.
    diffMinutes = diffMinutes % 60;
    return diffHours > 36 ? (
      ""
    ) : (
      <div className="countdown-date">
        <i className="mdi mdi-clock-outline hover"> </i>
        {diffHours + " h " + diffMinutes + " min"}
      </div>
    );
  }

  function isDateTimeOlder(orderstatus, dateTimeStr) {
    const dateTime = new Date(dateTimeStr);
    const now = new Date();
    return dateTime < now && orderstatus !== "finished";
  }
  const assignVehicle = () => {
    setAssigningVehicle(true);
    axios
      .post(
        baseURL + "/customer-assign-vehicle",
        {
          orderid: findADriver.orderid,
          vehicleid: assignedVehicle,
        },
        Authorization("POST")
      )
      .then((response) => {
        fetchOrders(true);
      })
      .catch((e) => {
        console.log("/customer-assign-vehicle err", e);
        alert(e);
        setAssigningVehicle(false);
      });
  };

  const getOrderConversations = (orderid) => {
    setAddingConversation(true);
    getOrderFiles(orderid);
    axios
      .get(
        baseURL + "/customer-order-conversations?orderid=" + orderid,
        Authorization("GET")
      )
      .then((response) => {
        setOrderconversations(response.data.conversation);
      })
      .catch((e) => {
        console.log("/update-driver err", e);
        alert(e);
      })
      .finally(() => setAddingConversation(false));
  };
  const getOrderFiles = (orderid) => {
    setAddingConversation(true);
    axios
      .get(
        baseURL + "/customer-job-files?orderid=" + orderid,
        Authorization("GET")
      )
      .then((response) => {
        setOrderFiles(response.data);
      })
      .catch((e) => {
        console.log("/getOrderFiles err", e);
        alert(e);
      })
      .finally(() => {
        setAddingConversation(false);
        // refreshAdminToken();
      });
  };
  // const refreshAdminToken = (orderid) => {
  //   axios
  //     .get(baseURL + "/refresh-customer-token", Authorization("GET"))
  //     .then((response) => {
  //       if (response.data["session-id-qt"]) {
  //         cookie.save("session-id-qt", response.data["session-id-qt"], {
  //           path: "/",
  //           maxAge: 86400,
  //           secure: true,
  //         });
  //         cookie.save("media-id-qt", response.data["session-id-qt"], {
  //           path: "/",
  //           domain: "qiktruck.co.za",
  //           maxAge: 86400,
  //           secure: true,
  //         });
  //       }
  //     })
  //     .catch((e) => {
  //       console.log("/getOrderFiles err", e);
  //       alert(e);
  //     });
  // };
  const addConversation = (orderid) => {
    setAddingConversation(true);
    axios
      .post(
        baseURL + "/customer-add-conversation",
        {
          message: newComment,
          orderid: startChat.split("ax-x-x")[1],
        },
        Authorization("POST")
      )
      .then(() => {
        setAddingConversation(false);
        getOrderConversations(orderid);
        setNewComment("");
      })
      .catch((e) => {
        console.log("/customer-add-conversation err", e);
        alert(e);
      })
      .finally(() => setAddingConversation(false));
  };
  const notifyViaSMS = (orderid, mobilenumber, message) => {
    setAddingConversation(true);
    axios
      .post(
        baseURL + "/customer-trip-sms",
        {
          mobilenumber,
          message,
          orderid,
        },
        Authorization("POST")
      )
      .then(() => {
        setAddingConversation(false);
        getOrderConversations(orderid);
        setNewComment("");
      })
      .catch((e) => {
        console.log("/trip-sms err", e);
        alert(e);
      })
      .finally(() => setAddingConversation(false));
  };
  // const getOrderStatuses = (orderid) => {
  //   axios
  //     .get(baseURL + "/order-statuses?orderid=" + orderid)
  //     .then((response) => {
  //       setOrderStatuses(response.data);
  //     })
  //     .catch((e) => {
  //       console.log("/update-driver err", e);
  //       alert(e);
  //     });
  // };
  // const stopOrder = (orderid) => {
  //   setUpdatingVehicle(true);
  //   axios
  //     .post(
  //       baseURL + "/customer-stop-order",
  //       {
  //         orderid,
  //       },
  //       Authorization("POST")
  //     )
  //     .then(() => {
  //       fetchOrders(true);
  //     })
  //     .catch((e) => {
  //       console.log("/stop-order err", e);
  //       alert(e);
  //     })
  //     .finally(() => setUpdatingVehicle(false));
  // };
  // const getDeliveryStatement = (deliverystatus) => {
  //   setSendingDeliveryStatement(true);
  //   axios
  //     .post(
  //       baseURL + "/delivery-statement",
  //       {
  //         deliverystatus,
  //       },
  //       Authorization("POST")
  //     )
  //     .then((response) => {
  //       alert("Check your email for the delivery statement");
  //     })
  //     .catch((e) => {
  //       console.log("/delivery-statement err", e);
  //       alert("An error occurred, please try again");
  //     })
  //     .finally(() => setSendingDeliveryStatement(false));
  // };

  // const [showText, setShowText] = useState(true);
  const applyFilter = (obj) => {
    const orderstatus = // orderstatus
      ordersFilter.orderstatus === "all"
        ? true
        : obj.orderstatus === ordersFilter.orderstatus;
    let vehiclestatus = true; //vehicleid

    if (ordersFilter.vehicleid === true) vehiclestatus = obj.vehicleid != null;
    else if (ordersFilter.vehicleid === null)
      vehiclestatus = obj.vehicleid === null;

    let orderid = true; //vehicleid
    let sxh = ordersFilter?.search?.trim();
    if (sxh !== "all")
      orderid =
        obj?.orderid?.toLowerCase()?.indexOf(sxh) > -1 ||
        obj?.quoteid?.toLowerCase()?.indexOf(sxh) > -1 ||
        obj?.email?.toLowerCase()?.indexOf(sxh) > -1 ||
        obj?.description?.toLowerCase()?.indexOf(sxh) > -1 ||
        obj?.firstname?.indexOf(sxh) > -1 ||
        obj?.lastname?.toLowerCase()?.indexOf(sxh) > -1 ||
        obj?.driverfirstname?.toLowerCase()?.indexOf(sxh) > -1 ||
        obj?.drivermobilenumber?.toLowerCase()?.indexOf(sxh) > -1 ||
        obj?.licenseplatenumber?.toLowerCase()?.indexOf(sxh) > -1 ||
        obj?.mobilenumber?.indexOf(sxh) > -1;

    let deliverystatus =
      processedFilter.length > 0
        ? obj.deliverystatus === processedFilter
        : true;

    return orderstatus && vehiclestatus && orderid && deliverystatus;
  };
  const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
    let R = 6371; // Radius of the earth in km
    let dLat = deg2rad(lat2 - lat1); // deg2rad below
    let dLon = deg2rad(lon2 - lon1);
    let a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c; // Distance in km
    return d;
  };

  const deg2rad = (deg) => {
    return deg * (Math.PI / 180);
  };
  const getImage = (trucktype) => {
    try {
      return `https://media.qiktruck.co.za/3d-${trucktype}.png`;
    } catch (error) {
      return "";
    }
  };
  const [showModal, setShowModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showBookTripModal, setShowBookTripModal] = useState(false);
  const [canBookTrips, setCanBookTrips] = useState(true);

  const openBookTripModal = () => {
    if (canBookTrips === false) return;
    setMainvehicleid(undefined);
    setMaintrucktype(undefined);
    setMainOrder(undefined);
    setShowBookTripModal(true);
  };
  const openBookTripModalRef = useRef(openBookTripModal);
  openBookTripModalRef.current = openBookTripModal;

  const [mainvehicleid, setMainvehicleid] = useState("");
  const [maintrucktype, setMaintrucktype] = useState("");
  const [mainOrder, setMainOrder] = useState("");
  const [mainDriver, setMainDriver] = useState(null);

  const onAction = (e) => {
    // setTimers({ ...timers, isTimedOut: false });
    // setShowModal(false);
  };

  const onActive = (e) => {
    // setTimers({ ...timers, isTimedOut: false });
    setShowModal(false);
  };

  const onIdle = (e) => {
    // setTimers({ ...timers, showModal: true, isTimedOut: true });
    // timers.reset();
    setShowModal(true);
  };

  const handleClose = () => {
    // this.setState({ showModal: false });
    setShowModal(false);
  };

  const handleLogout = () => {
    // setTimers({ ...timers, showModal: false });
    setShowModal(false);
  };
  const onPrompt = () => {
    // Fire a Modal Prompt
    setShowModal(true);
  };

  function countExpiredDates(dates) {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Reset time to midnight for comparison

    let expiredCount = 0;

    for (let date of dates) {
      const parsedDate = new Date(date);
      parsedDate.setHours(0, 0, 0, 0); // Reset time to midnight for comparison

      if (parsedDate < currentDate) {
        expiredCount++;
      }
    }

    return expiredCount;
  }

  function bookOnDemandVehicle(vehicle) {
    if (canBookTrips === false) return;
    setMainvehicleid(vehicle.vehicleid);
    setMaintrucktype(vehicle.trucktype);
    setMainOrder(vehicle.order);
    setMainDriver(vehicle.driver || null);
    setShowBookTripModal(true);
  }
  useIdleTimer({
    onPrompt,
    onIdle,
    onActive,
    onAction,
    timeout: 1000 * 60 * 20,
    promptTimeout: 0,
    events: ["keydown", "wheel", "DOMMouseScroll", "mousewheel", "mousedown"],
    immediateEvents: [],
    debounce: 0,
    throttle: 0,
    eventsThrottle: 200,
    element: document,
    startOnMount: true,
    startManually: false,
    stopOnIdle: false,
    crossTab: false,
    name: "idle-timer",
    syncTimers: 0,
    leaderElection: false,
  });
  const getCustomerProfile = () => {
    axios
      .get(baseURL + "/customer-profile", {
        headers: {
          "Content-Type": "application/json",
          Authorization: cookie.load("session-id-qt"),
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (
            response.data.firstname &&
            response.data.customerid &&
            (response.data.promocode || response.data.hasTeam || response.data.teamRole)
          ) {
            // //set cookie
            cookie.save("ctName", response.data.firstname, {
              path: "/",
              maxAge: 86400,
              secure: true,
            });
            cookie.save("localsessionid", response.data.customerid, {
              path: "/",
              maxAge: 86400,
              secure: true,
            });
            cookie.save("promocode", response.data.promocode, {
              path: "/",
              maxAge: 86400,
              secure: true,
            });

            writeToLocalStorage(
              "quotations",
              response.data.stats.quotations
                ? response.data.stats.quotations
                : 0
            );
            writeToLocalStorage(
              "orders",
              response.data.stats.orders ? response.data.stats.orders : 0
            );
            writeToLocalStorage(
              "completed",
              response.data.stats.completed ? response.data.stats.completed : 0
            );
            writeToLocalStorage(
              "processing",
              response.data.stats.processing
                ? response.data.stats.processing
                : 0
            );
            writeToLocalStorage(
              "storagehours",
              response.data.stats.storagehours
                ? response.data.stats.storagehours
                : 0
            );
            writeToLocalStorage(
              "cancelled",
              response.data.stats.cancelled ? response.data.stats.cancelled : 0
            );
            writeToLocalStorage(
              "totalcost",
              response.data.stats.totalcost ? response.data.stats.totalcost : 0
            );
            writeToLocalStorage(
              "totaldistance",
              response.data.stats.totaldistance
                ? response.data.stats.totaldistance
                : 0
            );
            writeToLocalStorage(
              "storages",
              response.data.stats.storages ? response.data.stats.storages : 0
            );
            writeToLocalStorage(
              "conversations",
              response.data.stats.conversations
                ? response.data.stats.conversations
                : 0
            );
            writeToLocalStorage(
              "vehicles",
              response.data.stats.vehicles ? response.data.stats.vehicles : 0
            );
            writeToLocalStorage(
              "totalcostpaid",
              response.data.stats.totalcostpaid
                ? response.data.stats.totalcostpaid
                : 0
            );
            setCanBookTrips(response.data.canBookTrips !== false);
          }
        }
      });
  };
  const renderOderDetails = () => {
    if (!order) return null;

    const handleDownloadInvoice = (orderId) => {
      setDownloadingInvoiceId(orderId);
      downloadCustomerInvoice(orderId, cookie.load("session-id-qt")).finally(() => {
        setDownloadingInvoiceId(null);
      });
    };

    const paid = isOrderPaid(order);
    const payUrl = paid ? null : getTrackOrderPayUrl(order);

    return (
      <OrderDetails
        order={order}
        startChat={startChat}
        setStartChat={setStartChat}
        setOrder={setOrder}
        orderFiles={orderFiles}
        orderconversations={orderconversations}
        getOrderFiles={getOrderFiles}
        getOrderConversations={getOrderConversations}
        newComment={newComment}
        setNewComment={setNewComment}
        addingConversation={addingConversation}
        addConversation={addConversation}
        getImage={getImage}
        onDownloadInvoice={handleDownloadInvoice}
        payUrl={payUrl}
        orderPaid={paid}
        downloadingInvoice={
          downloadingInvoiceId != null &&
          String(downloadingInvoiceId) === String(order.orderid)
        }
      />
    );
  };
  useEffect(() => {
    let mounted = true;
    fetchVehiclesDrivers(true);
    fetchOrders(mounted);
    getCustomerProfile();
    fetchTopActiveDrivers();
    // Auto-open order when redirected from the navbar search.
    try {
      const params = new URLSearchParams(window.location.search);
      const qOrderId = params.get("orderid");
      if (qOrderId) {
        filterOrders((prev) => ({ ...(prev || {}), search: qOrderId, orderstatus: "all", vehicleid: "all" }));
        try {
          window.history.replaceState({}, "", window.location.pathname);
        } catch (_e) {
          // ignore
        }
      }
      // Auto-open the Book Trip modal when the navbar sends us here with ?booknew=1
      if (params.get("booknew") === "1") {
        openBookTripModalRef.current();
        try {
          window.history.replaceState({}, "", window.location.pathname);
        } catch (_e) {
          // ignore
        }
      }
    } catch (e) {
      // ignore
    }
    // Auto-show the dashboard tour on first visit.
    try {
      if (!localStorage.getItem("qt-dashboard-tour-seen")) {
        setTimeout(() => setTourOpen(true), 800);
      }
    } catch (e) {
      // ignore
    }
    // Listen for navbar search selections while on dashboard (no reload).
    const handleNavbarSearch = (event) => {
      const order = event.detail;
      if (!order || !order.orderid) return;
      filterOrders((prev) => ({
        ...(prev || {}),
        search: order.orderid,
        orderstatus: order.orderstatus || "all",
        vehicleid: "all",
      }));
      setOPaginator(0);
    };
    window.addEventListener("qt-search-order", handleNavbarSearch);

    // Listen for the navbar "Book new trip" button
    const handleNavbarBookNewTrip = () => {
      openBookTripModalRef.current();
    };
    window.addEventListener("qt-book-new-trip", handleNavbarBookNewTrip);

    return () => {
      window.removeEventListener("qt-search-order", handleNavbarSearch);
      window.removeEventListener("qt-book-new-trip", handleNavbarBookNewTrip);
    };
  }, []);

  return (
    <div>
      <IdleModal
        showModal={showModal}
        handleClose={() => handleClose}
        handleLogout={() => handleLogout}
      />
      <PaymentsPromptModal
        showPaymentModal={showPaymentModal}
        setShowPaymentModal={setShowPaymentModal}
        payments={ordersonly.filter(
          (o) =>
            !o.paymentid &&
            (o.orderstatus === "completed" || o.orderstatus === "finished")
        )}
      />
      {showBookTripModal && (
        <BookTripModal
          showBookTripModal={showBookTripModal}
          setShowBookTripModal={setShowBookTripModal}
          vehicleid={mainvehicleid}
          driver={
            mainDriver ||
            vehicles.find((v) => v.vehicleid === mainvehicleid)
          }
          trucktype={maintrucktype}
          order={mainOrder}
          topDrivers={topActiveDrivers}
          onSelectTopDriver={rebookWithTopDriver}
        />
      )}

      <Modal
        isOpen={typeof findADriver !== "undefined"}
        size={"sm"}
        onOpened={() => {
          const vs = [];
          for (let index = 0; index < vehicles.length; index++) {
            const element = vehicles[index];
            element["distance"] = getDistanceFromLatLonInKm(
              element.homelat,
              element.homelng,
              findADriver.collectionlat,
              findADriver.collectionlng
            );
            element["distancefomdestination"] = getDistanceFromLatLonInKm(
              element.homelat,
              element.homelng,
              findADriver.deliverylat,
              findADriver.deliverylng
            );
            vs.push(element);
          }
          vs.sort((a, b) => (a.distance < b.distance ? 1 : -1));
          vs.sort((a, b) => (a.vehiclestatus > b.vehiclestatus ? 1 : -1));
          setNearbyVehicles(vs);
        }}
      >
        <ModalBody>
          <Row>
            <Col lg={12} sm={12}>
              <FormGroup>
                <div className="vehicle-finder">
                  {" "}
                  <img
                    src={getImage(
                      findADriver?.trucktype.length < 20
                        ? findADriver?.trucktype
                        : findADriver?.truckimage
                    )}
                    alt=""
                    height="50"
                  />
                  <div className="vehicle-job-details">
                    <b>
                      <CurrencyFormat
                        value={findADriver?.sellingprice / 100}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"R"}
                      />
                    </b>
                    <br />
                    {findADriver?.collectionaddress} &gt;&gt;
                    {findADriver?.deliveryaddress}
                    <br />
                    {findADriver?.collectiondate}-{findADriver?.collectiontime}
                    <br />
                    {findADriver?.tripdistance / 1000}km
                    <br />
                  </div>
                  {assignedVehicle?.length > 0 && (
                    <Button
                      color="primary"
                      onClick={() => {
                        if (
                          assignedVehicle?.length > 0 &&
                          findADriver.orderstatus
                        )
                          assignVehicle();
                        else setFindADriver(undefined);
                      }}
                      disabled={assigningVehicle}
                    >
                      Assign vehicle
                    </Button>
                  )}
                </div>
                <Input
                  id="vehiclesearch"
                  name="vehiclesearch"
                  placeholder="search for drivers"
                  onChange={(e) => {
                    setFilterDrivers(e.target.value);
                  }}
                  defaultValue={filterDrivers}
                />
              </FormGroup>
              <div className="vehicles-picker-list">
                {nearbyVehicles
                  ?.filter((f) => {
                    if (filterDrivers.length < 1) return true;
                    return (
                      f.firstname
                        .toLowerCase()
                        .indexOf(filterDrivers.toLowerCase()) > -1 ||
                      f.lastname
                        .toLowerCase()
                        .indexOf(filterDrivers.toLowerCase()) > -1 ||
                      f.licensenumber
                        .toLowerCase()
                        .indexOf(filterDrivers.toLowerCase()) > -1 ||
                      f.vehicleid
                        .toLowerCase()
                        .indexOf(filterDrivers.toLowerCase()) > -1 ||
                      f.drivermobilenumber
                        ?.toLowerCase()
                        .indexOf(filterDrivers.toLowerCase()) > -1 ||
                      f.mobilenumber
                        ?.toLowerCase()
                        .indexOf(filterDrivers.toLowerCase()) > -1 ||
                      f.trucktype
                        ?.toLowerCase()
                        .indexOf(filterDrivers.toLowerCase()) > -1 ||
                      f.idnumber
                        ?.toLowerCase()
                        .indexOf(filterDrivers.toLowerCase()) > -1
                    );
                  })
                  ?.map((v) => (
                    <div
                      key={v.vehicleid}
                      className={
                        "find-a-vehicle " +
                        (v.vehicleid === assignedVehicle ? "selected" : "") +
                        (v.vehicleid === findADriver?.vehicleid ||
                        findADriver?.quotevehicleid === v.vehicleid
                          ? " active"
                          : " ") +
                        " " +
                        v.vehiclestatus
                      }
                      onClick={() =>
                        v.vehiclestatus === "available"
                          ? setAssignedVehicle(v.vehicleid)
                          : () => {}
                      }
                    >
                      {v.vehiclestatus !== "available" && (
                        <i
                          className="mdi mdi-email orange"
                          onClick={() =>
                            notifyViaSMS(
                              v.vehicleid,
                              v.mobilenumber,
                              `[SMS] QikTruck Boost: ${v.firstname} continue your QikTruck registration and earn with your vehicle?. https://driver.qiktruck.co.za/?v=${v.vehicleid}.`
                            )
                          }
                        >
                          {" "}
                        </i>
                      )}
                      <img src={getImage(v?.trucktype)} alt="" height="30" />
                      {v.packagetype === "easydrive" && (
                        <i
                          className="mdi mdi-fire orange"
                          onClick={() =>
                            notifyViaSMS(
                              v.vehicleid,
                              v.mobilenumber,
                              `[SMS] ${v.firstname} Boost your profile and earn with your vehicle for as low as R350 at QikTruck. https://driver.qiktruck.co.za/?v=${v.vehicleid}.`
                            )
                          }
                        >
                          {" "}
                        </i>
                      )}
                      {v.trips}-{v.firstname} {v.lastname}{" "}
                      <a
                        className="mdi mdi-phone"
                        href={"tel:" + v.mobilenumber}
                      >
                        {v.mobilenumber}
                      </a>
                      -<strong>{Math.floor(v.distance)}km</strong>
                      {" or "}
                      <strong>{Math.floor(v.distancefomdestination)}km</strong>
                    </div>
                  ))}
              </div>
            </Col>
            <Col lg={3} sm={12}></Col>
            <br />
            <br />
            <Col lg={3} sm={12}>
              <button
                className="float-right-button"
                onClick={() => setFindADriver(undefined)}
              >
                Cancel
              </button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      {
        <TabContent activeTab={"1"} className="custom-panes">
          <TabPane tabId="1">
            <div className="book-actions-container">
              <Tour
                open={tourOpen}
                onClose={() => {
                  setTourOpen(false);
                  try {
                    localStorage.setItem("qt-dashboard-tour-seen", "1");
                  } catch (e) {
                    // ignore
                  }
                }}
                steps={[
                  {
                    title: "Top Active Drivers",
                    description:
                      "Your most-used drivers from the last 60 days. Tap any driver to see their last 10 trips and rebook instantly.",
                    target: () => topDriversRef.current,
                  },
                  {
                    title: "Insights",
                    description:
                      "Quick view of billing due, today’s weather near your usual pickups, and privacy-safe tips from your trip patterns.",
                    target: () =>
                      document.querySelector(".qt-dash-insights") ||
                      statusFilterRef.current,
                  },
                  {
                    title: "Recent Quotations",
                    description:
                      "Turn previously-generated price quotations into bookings without re-entering trip details.",
                    target: () => quotationsRef.current,
                  },
                  {
                    title: "Filter Trips by Status",
                    description:
                      "Use the status tiles below to filter between No Driver, Assigned, Accepted, In Progress and Processed trips.",
                    target: () => statusFilterRef.current,
                  },
                  {
                    title: "Track Your Orders",
                    description:
                      "Use the search bar in the top navigation to find orders by ID, customer, driver, vehicle or phone number.",
                    target: () =>
                      document.querySelector(".navbar-order-search input") ||
                      document.querySelector(".main-search"),
                  },
                ]}
              />
              <div className="book-actions">
                <div className="book-actions-inner">
                  <div ref={topDriversRef}>
                    <TopActiveDriversPanel
                      drivers={topActiveDrivers}
                      loading={loadingTopDrivers}
                      onRefresh={fetchTopActiveDrivers}
                      onTakeTour={() => setTourOpen(true)}
                      onDriverSelect={(d) => {
                        setSelectedDriver(d);
                        fetchDriverRecentTrips(d.vehicleid);
                      }}
                    />
                  </div>
                </div>
              </div>

              <DashboardInsightCards />

              {/* Multi-stop + Recent Quotations */}
              <div ref={quotationsRef} className="qt-dash-quick-links">
                {canBookTrips ? (
                  <a
                    href="/book/multi-stop"
                    className="qt-dash-chip"
                    title="Book a route with multiple pickups or drop-offs"
                  >
                    <i className="mdi mdi-map-marker-path" />
                    Multi-stop route
                  </a>
                ) : null}
                <Tooltip
                  title="Quotations are trip price estimates you've generated. Click a quotation to turn it into a booking without re-entering the details."
                  placement="bottomLeft"
                >
                  <button
                    type="button"
                    className={
                      "qt-dash-chip" + (showQuotations ? " is-active" : "")
                    }
                    onClick={() => {
                      setShowQuotations(!showQuotations);
                      if (!showQuotations && quotations.length === 0) fetchQuotations();
                    }}
                  >
                    <i className="mdi mdi-format-list-bulleted" />
                    Recent Quotations
                    {quotations.length > 0 ? (
                      <span className="qt-dash-chip-count">{quotations.length}</span>
                    ) : null}
                  </button>
                </Tooltip>
                {showQuotations ? (
                  <button
                    type="button"
                    className="qt-dash-chip"
                    onClick={() => fetchQuotations()}
                    disabled={loadingQuotations}
                  >
                    <i className="mdi mdi-refresh" />
                    Refresh
                  </button>
                ) : null}
              </div>
              {showQuotations && (
                <div className="orders-container" style={{ marginBottom: 16 }}>
                  {loadingQuotations && (
                    <div className="spinner-parent">
                      <div className="spinner"><Spinner /> quotations</div>
                    </div>
                  )}
                  {!loadingQuotations && quotations.length === 0 && (
                    <div className="empty-state-container">
                      <div className="empty-state">
                        <div className="empty-state-icon">
                          <i className="mdi mdi-receipt"></i>
                        </div>
                        <h4>No quotations yet</h4>
                        <p>Your recent quotations will appear here</p>
                      </div>
                    </div>
                  )}
                  {quotations.length > 0 && (
                    <Table striped>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Vehicle</th>
                          <th>Route</th>
                          <th>Distance</th>
                          <th>Price</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {quotations.map((q) => {
                          const image = getImage(q.trucktype);
                          return (
                            <tr key={q.quoteid}>
                              <td>
                                <b>{moment(new Date(q.dateadded)).format("MMM DD, YYYY")}</b>
                                <br />
                                <small style={{ color: "#999" }}>
                                  {q.collectiondate} {q.collectiontime}
                                </small>
                              </td>
                              <td>
                                <img src={image} alt="" height="20" style={{ marginRight: 4 }} />
                                {q.trucktype}
                              </td>
                              <td>
                                <div style={{ fontSize: 12 }}>
                                  <i className="mdi mdi-map-marker" style={{ color: "green" }}></i>{" "}
                                  {q.collectionaddress
                                    ? q.collectionaddress.length > 30
                                      ? q.collectionaddress.substring(0, 30) + "..."
                                      : q.collectionaddress
                                    : "-"}
                                </div>
                                <div style={{ fontSize: 12 }}>
                                  <i className="mdi mdi-map-marker-check" style={{ color: "red" }}></i>{" "}
                                  {q.deliveryaddress
                                    ? q.deliveryaddress.length > 30
                                      ? q.deliveryaddress.substring(0, 30) + "..."
                                      : q.deliveryaddress
                                    : "-"}
                                </div>
                              </td>
                              <td>{q.tripdistance ? (q.tripdistance / 1000).toFixed(1) + " km" : "-"}</td>
                              <td>
                                <CurrencyFormat
                                  value={q.sellingprice / 100}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"R"}
                                  decimalScale={2}
                                />
                              </td>
                              <td>
                                <div className={"delivery-status " + (q.quotationstatus || "pending")}>
                                  {q.quotationstatus || "pending"}
                                </div>
                              </td>
                              <td>
                                <div className="vehicle-buttons-container">
                                  {canBookTrips ? (
                                  <button
                                    className="book-again-btn"
                                    onClick={() => {
                                      bookOnDemandVehicle({
                                        trucktype: q.trucktype,
                                        vehicleid: undefined,
                                        order: {
                                          collectionlat: q.collectionlat,
                                          collectionlng: q.collectionlng,
                                          deliverylat: q.deliverylat,
                                          deliverylng: q.deliverylng,
                                          collectionaddress: q.collectionaddress,
                                          deliveryaddress: q.deliveryaddress,
                                          collectiondate: q.collectiondate,
                                          collectiontime: q.collectiontime,
                                          description: q.description,
                                          mobilenumber: q.prospectmobilenumber,
                                          email: q.prospectemail,
                                          promocode: q.promocode,
                                          floors: q.floors,
                                          runners: q.runners,
                                        },
                                      });
                                    }}
                                  >
                                    <i className="mdi mdi-refresh"></i> Book again
                                  </button>
                                  ) : null}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  )}
                </div>
              )}

              {/* Driver Recent Trips Drawer */}
              <DriverTripsDrawer
                driver={selectedDriver}
                trips={driverTrips}
                loading={loadingDriverTrips}
                onClose={() => setSelectedDriver(null)}
                onOpenTrip={openTripFromDriverPanel}
                onDuplicateTrip={canBookTrips ? duplicateTripAsNewBooking : undefined}
              />

              <div ref={statusFilterRef}>
                <div
                  style={{
                    padding: "4px 12px 0",
                    fontSize: 11,
                    color: "#888",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <Tooltip
                    title={
                      <div style={{ lineHeight: 1.5 }}>
                        <div><b>No Driver</b> - new trips awaiting a driver match</div>
                        <div><b>Assigned</b> - a driver is selected but hasn't accepted yet</div>
                        <div><b>Accepted</b> - driver confirmed and is en route</div>
                        <div><b>In Progress</b> - collection/delivery underway</div>
                        <div><b>Processed</b> - finished trips (delivered / returned / cancelled)</div>
                      </div>
                    }
                    placement="topLeft"
                  >
                    <span style={{ cursor: "help" }}>
                      <i
                        className="mdi mdi-information-outline"
                        style={{ color: "#f5861f" }}
                      ></i>{" "}
                      Filter trips by status - hover for details
                    </span>
                  </Tooltip>
                </div>

                <div className="book-actions-row">
                <button
                  className={
                    "in-review trip-statuses " +
                    (_.isEqual(ordersFilter, {
                      orderstatus: "in-review",
                      search:
                        ordersFilter.search.length > 0
                          ? ordersFilter.search
                          : "all",
                      vehicleid: null,
                    })
                      ? "filteredorder"
                      : "")
                  }
                  onClick={() => {
                    filterOrders({
                      orderstatus: "in-review",
                      vehicleid: null,
                      search:
                        ordersFilter.search.length > 0
                          ? ordersFilter.search
                          : "all",
                    });
                    setOPaginator(0);

                    fetchOrders(true);
                    setProcessedFilter("");
                  }}
                >
                  <div className="status-count">
                    {ordersonly &&
                      ordersonly.filter(
                        (obj) =>
                          obj.orderstatus === "in-review" &&
                          obj.vehicleid == null
                      ).length}
                  </div>
                  <div className="status-label">
                    <i className="mdi mdi-account-off"></i> No Driver
                  </div>
                  {countExpiredDates(
                    ordersonly &&
                      ordersonly
                        .filter(
                          (obj) =>
                            obj.orderstatus === "in-review" &&
                            obj.vehicleid == null
                        )
                        .map((o) => o.collectiondate + " " + o.collectiontime)
                  ) > 0 && (
                    <div className="expired-count">
                      {countExpiredDates(
                        ordersonly &&
                          ordersonly
                            .filter(
                              (obj) =>
                                obj.orderstatus === "in-review" &&
                                obj.vehicleid == null
                            )
                            .map(
                              (o) => o.collectiondate + " " + o.collectiontime
                            )
                      )}
                    </div>
                  )}
                </button>
                <button
                  className={
                    "in-review trip-statuses " +
                    (_.isEqual(ordersFilter, {
                      orderstatus: "in-review",
                      vehicleid: true,
                      search:
                        ordersFilter.search.length > 0
                          ? ordersFilter.search
                          : "all",
                    })
                      ? "filteredorder"
                      : "")
                  }
                  onClick={() => {
                    filterOrders({
                      orderstatus: "in-review",
                      vehicleid: true,
                      search:
                        ordersFilter.search.length > 0
                          ? ordersFilter.search
                          : "all",
                    });
                    setOPaginator(0);

                    setProcessedFilter("");
                  }}
                >
                  <div className="status-count">
                    {ordersonly &&
                      ordersonly.filter(
                        (obj) =>
                          obj.orderstatus === "in-review" &&
                          obj.vehicleid != null
                      ).length}
                  </div>
                  <div className="status-label">
                    <i className="mdi mdi-account-check"></i> Assigned
                  </div>
                  {countExpiredDates(
                    ordersonly &&
                      ordersonly
                        .filter(
                          (obj) =>
                            obj.orderstatus === "in-review" &&
                            obj.vehicleid != null
                        )
                        .map((o) => o.collectiondate + " " + o.collectiontime)
                  ) > 0 && (
                    <div className="expired-count">
                      {countExpiredDates(
                        ordersonly &&
                          ordersonly
                            .filter(
                              (obj) =>
                                obj.orderstatus === "in-review" &&
                                obj.vehicleid != null
                            )
                            .map(
                              (o) => o.collectiondate + " " + o.collectiontime
                            )
                      )}
                    </div>
                  )}
                </button>
                <button
                  className={
                    "accepted turq trip-statuses " +
                    (_.isEqual(ordersFilter, {
                      orderstatus: "accepted",
                      vehicleid: "all",
                      search:
                        ordersFilter.search.length > 0
                          ? ordersFilter.search
                          : "all",
                    })
                      ? "filteredorder"
                      : "")
                  }
                  onClick={() => {
                    filterOrders({
                      orderstatus: "accepted",
                      vehicleid: "all",
                      search:
                        ordersFilter.search.length > 0
                          ? ordersFilter.search
                          : "all",
                    });
                    setOPaginator(0);

                    setProcessedFilter("");
                  }}
                >
                  <div className="status-count">
                    {ordersonly &&
                      ordersonly.filter((obj) => obj.orderstatus === "accepted")
                        .length}
                  </div>
                  <div className="status-label">
                    <i className="mdi mdi-check-circle"></i> Accepted
                  </div>
                  {countExpiredDates(
                    ordersonly &&
                      ordersonly
                        .filter((obj) => obj.orderstatus === "accepted")
                        .map((o) => o.collectiondate + " " + o.collectiontime)
                  ) > 0 && (
                    <div className="expired-count">
                      {countExpiredDates(
                        ordersonly &&
                          ordersonly
                            .filter((obj) => obj.orderstatus === "accepted")
                            .map(
                              (o) => o.collectiondate + " " + o.collectiontime
                            )
                      )}
                    </div>
                  )}
                </button>
                <button
                  className={
                    "in-progress trip-statuses  " +
                    (_.isEqual(ordersFilter, {
                      orderstatus: "in-progress",
                      vehicleid: "all",
                      search:
                        ordersFilter.search.length > 0
                          ? ordersFilter.search
                          : "all",
                    })
                      ? "filteredorder"
                      : "")
                  }
                  onClick={() => {
                    filterOrders({
                      orderstatus: "in-progress",
                      vehicleid: "all",
                      search:
                        ordersFilter.search.length > 0
                          ? ordersFilter.search
                          : "all",
                    });
                    setOPaginator(0);

                    setProcessedFilter("");
                  }}
                >
                  <div className="status-count">
                    {ordersonly &&
                      ordersonly.filter(
                        (obj) => obj.orderstatus === "in-progress"
                      ).length}
                  </div>
                  <div className="status-label">
                    <i className="mdi mdi-truck-fast"></i> In Progress
                  </div>
                  {countExpiredDates(
                    ordersonly &&
                      ordersonly
                        .filter((obj) => obj.orderstatus === "in-progress")
                        .map((o) => o.collectiondate + " " + o.collectiontime)
                  ) > 0 && (
                    <div className="expired-count">
                      {countExpiredDates(
                        ordersonly &&
                          ordersonly
                            .filter((obj) => obj.orderstatus === "in-progress")
                            .map(
                              (o) => o.collectiondate + " " + o.collectiontime
                            )
                      )}
                    </div>
                  )}
                </button>
                <button
                  className={
                    "finished trip-statuses " +
                    (_.isEqual(ordersFilter, {
                      orderstatus: "finished",
                      vehicleid: "all",
                      search:
                        ordersFilter.search.length > 0
                          ? ordersFilter.search
                          : "all",
                    })
                      ? "filteredorder"
                      : "")
                  }
                  onClick={() => {
                    filterOrders({
                      orderstatus: "finished",
                      vehicleid: "all",
                      search:
                        ordersFilter.search.length > 0
                          ? ordersFilter.search
                          : "all",
                    });
                    setOPaginator(0);
                  }}
                >
                  <div className="status-count">
                    {ordersonly &&
                      ordersonly.filter((obj) => obj.orderstatus === "finished")
                        .length}
                    +
                  </div>
                  <div className="status-label">
                    <i className="mdi mdi-check-all"></i> Processed
                  </div>
                </button>
                <div className="trip-status-buttons float-right">
                  <button
                    className="flat-button"
                    onClick={() => {
                      filterOrders({
                        orderstatus: "finished",
                        deliverystatus: "delivered",
                        vehicleid: "all",
                        search: "all",
                      });
                    }}
                  >
                    Delivered
                  </button>
                  <button
                    className="flat-button"
                    onClick={() => {
                      filterOrders({
                        orderstatus: "finished",
                        deliverystatus: "returned",
                        vehicleid: "all",
                        search: "all",
                      });
                    }}
                  >
                    Returned
                  </button>
                  <button
                    className="flat-button"
                    onClick={() => {
                      filterOrders({
                        orderstatus: "finished",
                        deliverystatus: "cancelled",
                        vehicleid: "all",
                        search: "all",
                      });
                    }}
                  >
                    Cancelled
                  </button>
                </div>
              </div>
              </div>
            </div>

            {
              <div className="orders-container">
                {ordersonly && ordersonly.length > 0 && (
                  <Pagination aria-label="Page navigation example">
                    {ordersonly &&
                      new Array(
                        Math.ceil(
                          ordersonly.filter((obj) => applyFilter(obj)).length /
                            10
                        )
                      )
                        .fill("")
                        .map((e, index) => {
                          return (
                            <PaginationItem
                              key={index}
                              active={index === oPaginator}
                              onClick={() => {
                                setOPaginator(index);
                              }}
                            >
                              <PaginationLink>{index + 1}</PaginationLink>
                            </PaginationItem>
                          );
                        })}
                  </Pagination>
                )}
                {(loadingOrders || loadingOrders) && (
                  <div className="spinner-parent">
                    {loadingVehicles && (
                      <div className="spinner">
                        <Spinner />
                        vehicles
                      </div>
                    )}
                    {loadingOrders && (
                      <div className="spinner">
                        <Spinner />
                        orders
                      </div>
                    )}
                  </div>
                )}
                {ordersonly?.filter((obj) => applyFilter(obj)).length === 0 &&
                  ordersFilter.orderstatus !== "stats" && (
                    <div className="empty-state-container">
                      <div className="empty-state">
                        <div className="empty-state-icon">
                          <i className="mdi mdi-truck-check"></i>
                        </div>
                        <h4>
                          {ordersFilter.orderstatus === "accepted"
                            ? "No accepted trips right now"
                            : ordersFilter.orderstatus === "in-review"
                            ? "No trips waiting for a driver"
                            : ordersFilter.orderstatus === "in-progress"
                            ? "No trips in progress"
                            : ordersFilter.orderstatus === "finished"
                            ? "No processed trips in this view"
                            : "No trips match this filter"}
                        </h4>
                        <p>
                          {ordersFilter.orderstatus === "accepted"
                            ? "When a driver accepts a booking, it will show up here. Try Processed or clear filters to see recent history."
                            : "Switch status tiles above, clear filters, or book a new trip to get started."}
                        </p>
                        <div className="empty-state-actions">
                          {canBookTrips ? (
                            <button
                              className="action-button"
                              onClick={() => openBookTripModal()}
                            >
                              <i className="mdi mdi-plus-circle"></i> Book New Trip
                            </button>
                          ) : null}
                          <button
                            className="action-button secondary"
                            onClick={() => {
                              filterOrders({
                                orderstatus: "all",
                                vehicleid: "all",
                                search: "all",
                              });
                              setOPaginator(0);
                              setProcessedFilter("");
                            }}
                          >
                            <i className="mdi mdi-filter-remove"></i> Show all trips
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                <Table striped>
                  {ordersonly.length > 0 &&
                    ordersFilter.orderstatus !== "stats" && (
                      <>
                        <thead>
                          <tr>
                            <th>Order</th>
                            <th>Date</th>
                            <th>Vehicle</th>
                            <th>Actions</th>
                            <th>Comments</th>
                            <th>Price</th>
                            <th>Customer</th>
                            <th>Status</th>
                            <th> Description</th>
                          </tr>
                        </thead>
                      </>
                    )}
                  {renderOderDetails()}
                  <tbody>
                    {ordersonly &&
                      (ordersFilter.orderstatus === "finished"
                        ? [...ordersonly]
                        : ordersonly
                      )
                        .filter((obj) => applyFilter(obj))

                        .slice(oPaginator * 10, oPaginator * 10 + 10)
                        .map((order) => {
                          const image = getImage(order?.trucktype);
                          return (
                            <tr key={order.orderid}>
                              <td>
                                <button
                                  className="flat-button"
                                  onClick={() => {
                                    // getOrderStatuses(order.orderid);
                                    getOrderConversations(order.orderid);
                                    setStartChat("ax-x-x" + order.orderid);
                                    setOrder(order);
                                  }}
                                >
                                  {order.orderid.split("-")[0]}
                                </button>
                              </td>

                              <td>
                                {order.orderstatus === "in-review" &&
                                  getTimeRemaining(
                                    order.collectiondate +
                                      " " +
                                      order.collectiontime
                                  )}
                                {isDateTimeOlder(
                                  order.orderstatus,
                                  order.collectiondate +
                                    " " +
                                    order.collectiontime
                                ) && <i className="mdi mdi-alert red"> </i>}
                                <b>
                                  {moment(
                                    new Date(order.collectiondate)
                                  ).format("MMM DD")}
                                  {"   "}&bull;{"   "}
                                  {
                                    days[
                                      new Date(order.collectiondate).getDay()
                                    ]
                                  }
                                  {"   "}&bull;{"   "}
                                  {"   "}&bull;{"   "}
                                  {order.collectiontime}
                                </b>
                              </td>
                              <td>
                                <div className="vehicle-buttons">
                                  <div className="vehicle-info-container">
                                    <img src={image} alt="" height="20" />{" "}
                                    {order.trucktype},{" "}
                                    {(order.tripdistance / 1000).toFixed(1)}km
                                  </div>
                                  {order.driverfirstname && (
                                    <div
                                      className="order-driver-name"
                                      style={{
                                        fontSize: 11,
                                        color: "#6c757d",
                                        marginTop: 2,
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      <i
                                        className="mdi mdi-account"
                                        style={{ color: "#f5861f" }}
                                      ></i>{" "}
                                      {order.driverfirstname}
                                      {order.driverlastname
                                        ? " " +
                                          order.driverlastname.slice(0, 1) +
                                          "."
                                        : ""}
                                    </div>
                                  )}
                                  <div
                                    id={"ax-x-x" + order.orderid}
                                    style={{
                                      width: 10,
                                    }}
                                  ></div>
                                </div>
                              </td>
                              <td>
                                <div className="vehicle-buttons-container">
                                  {canBookTrips ? (
                                  <Tooltip title="Book the same route, vehicle and goods as a brand new on-demand trip">
                                    <button
                                      className="book-again-btn"
                                      onClick={() => {
                                        bookOnDemandVehicle({
                                          trucktype: order?.trucktype,
                                          vehicleid: order?.vehicleid,
                                          order: order,
                                          driver: order?.vehicleid
                                            ? {
                                                vehicleid: order.vehicleid,
                                                firstname:
                                                  order.driverfirstname,
                                                lastname:
                                                  order.driverlastname,
                                                trucktype: order.trucktype,
                                              }
                                            : null,
                                        });
                                      }}
                                    >
                                      <i className="mdi mdi-refresh"></i> Book again
                                    </button>
                                  </Tooltip>
                                  ) : null}
                                  {order.is_multi_stop &&
                                    order.total_stops > 1 &&
                                    Number(order.stop_sequence) === 1 &&
                                    order.orderstatus === "in-review" &&
                                    !order.vehicleid && (
                                      <Tooltip title="Reorder stops or update leg details before a driver is assigned">
                                        <a
                                          className="book-again-btn"
                                          href={`/route-set/${order.parent_orderid || order.orderid}`}
                                          style={{ marginLeft: 8, textDecoration: "none" }}
                                        >
                                          <i className="mdi mdi-map-marker-path"></i> Edit route
                                        </a>
                                      </Tooltip>
                                    )}
                                </div>
                              </td>
                              <td>
                                <button
                                  className="add-a-comment flat-button"
                                  onClick={() => {
                                    // getOrderStatuses(order.orderid);
                                    getOrderConversations(order.orderid);
                                    setStartChat("ax-x-x" + order.orderid);
                                    setOrder(order);
                                  }}
                                >
                                  {order.comments > 0 ? (
                                    <i className="mdi mdi-comment green">
                                      {order.comments}
                                    </i>
                                  ) : (
                                    <>
                                      <i className="mdi mdi-comment grey hover" />
                                    </>
                                  )}
                                </button>
                              </td>
                              <td>
                                <a
                                  href={
                                    "https://qiktruck.co.za/track-order?paynow=yes&orderid=" +
                                    order?.orderid +
                                    "&email=" +
                                    order?.email
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    fontSize: 13,
                                    fontWeight: "bold",
                                  }}
                                >
                                  <div className="vat-price">
                                    {/* {order.vat > 0 && order.vat !== null ? (
                                      <>
                                        <i className="mdi mdi-information-outline orange"></i>
                                        <div className="vat-price-hint">
                                          The price now includes VAT @ 15% of
                                          service fee: VAT: R
                                          <b>{(order.vat / 100)?.toFixed(2)}</b>
                                          , Service fee: R
                                          <b>
                                            {(order.commission / 100)?.toFixed(
                                              2
                                            )}
                                          </b>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )} */}
                                    <CurrencyFormat
                                      value={order.sellingprice / 100}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                      prefix={"R"}
                                      decimalScale={2}
                                    />
                                  </div>
                                </a>
                              </td>
                              <td>
                                {order.firstname} {order.lastname}
                              </td>

                              <td>
                                {order.deliverystatus && (
                                  <div
                                    className={
                                      "delivery-status " + order.deliverystatus
                                    }
                                  >
                                    {order.deliverystatus}{" "}
                                  </div>
                                )}
                              </td>
                              <td className="order-description-cell">
                                <div className="order-description-clamp">
                                  {order.description}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                  </tbody>
                </Table>{" "}
              </div>
            }
          </TabPane>
        </TabContent>
      }

      <PlacesAutocomplete style={{ display: "none" }} />
    </div>
  );
}

export default memo(MyComponent);
